import { render, staticRenderFns } from "./addBidangUsahaGems.vue?vue&type=template&id=2f4374ea&scoped=true&"
import script from "./addBidangUsahaGems.vue?vue&type=script&lang=js&"
export * from "./addBidangUsahaGems.vue?vue&type=script&lang=js&"
import style0 from "./addBidangUsahaGems.vue?vue&type=style&index=0&id=2f4374ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4374ea",
  null
  
)

export default component.exports